// @react
import React, { ReactElement } from 'react'
// @libraries
import { Control, useWatch } from 'react-hook-form'
// @typings
import { ProfileFormValues } from 'modules/common/forms/types/profile'
// @components
import Banner from '@bit/atd.web.banner'

/**
 *
 * @param control
 * @constructor
 */
const WatchPublicProfileBanner = ({
  control,
}: {
  control: Control<ProfileFormValues>
}): ReactElement => {
  /******************************************
   * HOOKS
   ******************************************/

  const watchPublic = useWatch<{ PublicProfile: string }>({
    control,
    name: 'publicProfile',
  })

  /******************************************
   * RENDER
   ******************************************/

  return (
    <Banner
      fullWidth
      icon={watchPublic ? 'lock-off' : 'lock-on'}
      header={`Your Public Profile is ${watchPublic ? 'ON' : 'OFF'}`}
    >
      The following will be visible to other users:
    </Banner>
  )
}

export default WatchPublicProfileBanner
